<template>
  <div class="map_container">
    <van-nav-bar
      title="选择位置"
      left-text="取消"
      right-text="确认"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <iframe
      id="mapPage"
      width="100%"
      height="100%"
      frameborder="0"
      src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=BOTBZ-KK5WU-L7AVP-2IK2Y-MR3Y3-MDBR4&referer=鲜枇杷名片"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titlename: "地图",
      LOCATION_INFO: {},
      poiaddress: "厦门软件园"
    };
  },
  created(){
    document.title='地图';
  },
  methods: {
    onClickRight: function() {
      this.$store.dispatch("changemapFun", this.LOCATION_INFO);
      /*  地址取值： {{this.$store.getters.getLocationinfo.address}} */
      this.$router.go(-1);
    },
    onClickLeft: function() {
      this.$router.go(-1);
    }
  },
  created: function() {
    var that = this;
    window.addEventListener(
      "message",
      function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module == "locationPicker") {
          let location = {};
          location.lat = loc.latlng.lat;
          location.lng = loc.latlng.lng;
          let LOCATION_INFO = {
            location: JSON.stringify(location),
            name: "",
            address: loc.poiaddress + loc.poiname
          };
          that.LOCATION_INFO = LOCATION_INFO;
          /*   window.localStorage.setItem('LOCATION_INFO', JSON.stringify(LOCATION_INFO)) */
        }
      },
      false
    );
  }
};
</script>

<style scoped>
.map_container {
  width: 100%;
  height: 100%;
}
#mapPage {
  height: calc(100% - 55px);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/map.vue